import { getSortIndex } from 'surface/sorter'
import store from 'surface/xstore'
import { generateClientId } from 'surface/xstore/helpers/post'
import { PostAttributes, PostPositionMap } from 'types'
// dependency
const DEFAULT_WIDTH = 200

const buildPost = (
  attr: PostAttributes = {},
  { state, getters } = { state: store.state, getters: store.getters },
): PostAttributes => {
  const timeNow = new Date()
  const wallLayout = getters.format
  let attributes = attr

  if (wallLayout === 'free' && !attributes.position) {
    attributes = Object.assign(getAutoPositionForNewPost(), attributes)
  }
  const finalAttributes: PostAttributes = {
    wall_id: state.wall.id,
    published: getters.canIModerate || !getters.requireApproval,
    author_id: state.user.id,
    width: DEFAULT_WIDTH,
    body: attributes.body || '',
    subject: attributes.subject || '',
    attachment: attributes.attachment || '',
    sort_index: attributes.sortIndex || attributes.sort_index || getSortIndex(),
    created_at: timeNow.toISOString(),
    wall_section_id: attributes.wallSectionId || attributes.wall_section_id,
    col_id: attributes.col_id,
    row_id: attributes.row_id,
    top: attributes.top,
    left: attributes.left,
    location_point: attributes.location_point || attributes.locationPoint,
    location_name: attributes.location_name || attributes.locationName,
  }
  finalAttributes.cid = generateClientId(finalAttributes)

  if (getters.isTable) {
    const { rowCid, colCid } = attributes
    if (rowCid && colCid) {
      finalAttributes.rowCid = rowCid
      finalAttributes.colCid = colCid
    }
  }

  return finalAttributes
}

const getAutoPositionForNewPost = (): PostPositionMap => {
  let maxY = 0
  document.querySelectorAll("[data-view-mode='show']").forEach(elem => {
    maxY = Math.max(maxY, elem.getBoundingClientRect().bottom)
  })
  if (maxY) {
    maxY += 8
  } else {
    maxY = 100
  }
  return { left: 16, top: maxY }
}

export default buildPost
